module.exports = __webpack_public_path__ + "static/pr-detail-4c0ae4f2d8d84f31ab2f65d47bbc6ae0.png";